import { render, staticRenderFns } from "./NisWorldMapPanel.vue?vue&type=template&id=c159418c&scoped=true"
import script from "./NisWorldMapPanel.vue?vue&type=script&lang=js"
export * from "./NisWorldMapPanel.vue?vue&type=script&lang=js"
import style0 from "./NisWorldMapPanel.vue?vue&type=style&index=0&id=c159418c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c159418c",
  null
  
)

export default component.exports